/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from "react";
import to from "await-to-js";
import NewOrEditAddress from "@/common-components-src/js/address/addressCreate";
import { Button, Typography, Radio, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Address } from "@/common-components-src/api/address/address.interface";
import AddressAdd from "@/common-components-src/js/address/icons/AddressAdd.svg";
import { getUserAddressList } from "@/common-components-src/api/address/address.api";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import JDILogin from "@/common-components-src/js/newlogin/index.newlogin";
import UKTruncatedTooltip from "@/common-components-src/components/UKTruncatedTooltip/index"
import Grid from "@mui/material/Grid2";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25425";
import { itemClickTrack } from "../utils/addressTrackUtils";
import PAGE_TYPE from "../const/pageType";
import styles from "./index.module.scss";

interface DataItemProps {
  handleAddressClose?: (params?: any) => void;
  isModal?: boolean;
  data?: Address | null;
}

const AddressBillingList: React.FC<DataItemProps> = ({ handleAddressClose, data }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [addressList, setAddressList] = useState<Address[] | null>(null);
  const [curSelectIndex, setCurSelectIndex] = useState(-1); // 当前选中的角标
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isUpdateOpenEdit, setIsUpdateOpenEdit] = useState(false); //是否为新添加的最后一条数据，如果是则打开编辑入口

  useEffect(() => {
    loginStatus();
  }, []);

  useEffect(() => {
    // 更新选中项
    if (data && addressList && addressList.length > 0) {
      // 遍历addressList查找与curLocalAddress的addressId匹配的元素
      const matchedIndex = addressList.findIndex(
        (item) => item.addressId === data.addressId,
      );
      if (matchedIndex !== -1) {
        // 把匹配到的这条数据设置位置到第一位了
        const matchedItem = addressList[matchedIndex];
        addressList.splice(matchedIndex, 1);
        addressList.unshift(matchedItem);
        handleRadioChange(0, true);
      }
    }
  }, [data, addressList]);

  const loginStatus = async () => {
    const { isLoggedIn } = await JDILogin.getInstance().getUserInfo();
    if (isLoggedIn) {
      getAddressList();
    }
    setIsLogin(isLoggedIn);
  };

  const getAddressList = async () => {
    const [err, result] = await to(getUserAddressList());

    if (err) {
      setAddressList(null);
    } else {
      const list = result?.data?.addressList;
      if (list) {
        setAddressList(list as Address[]);
      }
    }
  };

  const handleClose = () => {
    setOpenCreateModal(false);
    setIsUpdateOpenEdit(false);
  };

  const newCreateSaveClose = () => {
    handleClose();
  };

  const handleRadioChange = (index: number, isInit: boolean = false) => {
    setCurSelectIndex(index);
    if (isInit) {
      return;
    }
    if (addressList && addressList.length > 0) {
      if (handleAddressClose) {
        handleAddressClose(addressList[index]);
      }
    }
  };

  const getUpdateAddress = (address: Address) => {
    setIsUpdateOpenEdit(true);
    console.log("address", address);
    if (addressList && addressList.length > 0) {
      const lastAddress = addressList[addressList.length - 1];
      if (lastAddress.addressId === address.addressId) {
        // 如果新地址的 addressId 与列表中最后一条地址的 addressId 相同，则更新最后一条地址
        const updatedAddressList = [...addressList.slice(0, -1), address];
        setAddressList(updatedAddressList);
      } else {
        // 如果新地址的 addressId 与列表中最后一条地址的 addressId 不相同，则添加到列表末尾
        setAddressList([...addressList || [], address]);
      }
    } else {
      // 如果列表为空，则直接添加新地址
      setAddressList([address]);
    }
  };

  const cardFloor = (item: Address, index: number) => {
    if (!item) {
      return null;
    }
    const address = item as Address;
    return (
      <div className={styles.box}>
        <div className={styles.flex}>
          <UKTruncatedTooltip
            text={address?.name}
            tooltipStyles={styles.country}
            tooltipProps={{
              placement: "top",
              arrow: true
            }}
          />
          <div className={styles.phone}>{address?.areaCode ? "+" + address?.areaCode : ""} {address?.mobile}</div>
        </div>
        <div className={styles.flexRight}>
          <UKTruncatedTooltip
            text={address?.fullAddress}
            textLines={2}
            tooltipStyles={styles.address}
            tooltipProps={{
              placement: "top",
              arrow: true
            }}
          />
          {addressList && addressList.length - 1 === index && isUpdateOpenEdit && (
            <div
              className={styles.edit}
              exptag={"exp|" + EXPOSURE_RECORD.NeworderReceiverListPopup_Edit_Expo}
              data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
              data-exptag-json-param={JSON.stringify({ ...itemClickTrack(index, item), from_page: "3" })}
              onClick={(event) => {
                event.stopPropagation();
                setOpenCreateModal(true);
                sendClickTrack.NeworderReceiverListPopup_Edit({ ...itemClickTrack(index, item), from_page: "3" });
              }}>
              Edit
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}
      exptag={"exp|" + EXPOSURE_RECORD.NeworderReceiverListPopup_Expo}
      data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
      data-exptag-json-param={JSON.stringify({ from_page: "3" })}
    >
      <div className={styles.title}>Address or Postcode</div>
      <div className={styles.info}>
        Delivery options and delivery speeds may vary for different area
      </div>
      <div
        style={{ overflowY: "auto", maxHeight: "380px", minHeight: "248px", paddingBottom: "68px" }}
        className={styles["no-scrollbars"]}
      >
        {/* 地址列表 */}
        {isLogin && <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          {addressList && addressList.map((item, index) => [
            <Grid
              size={addressList && addressList?.length === 1 ? 12 : 6}
              key={index}>
              <div
                className={curSelectIndex === index ? styles.flexLeft : styles.flexLeftGray}
                exptag={"exp|" + EXPOSURE_RECORD.NeworderReceiverListPopup_Address_Card_Expo}
                data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                data-exptag-json-param={JSON.stringify({ ...itemClickTrack(index, item), from_page: "3" })}
                onClick={() => {
                  handleRadioChange(index);
                  sendClickTrack.NeworderReceiverListPopup_SelectAddress({ ...itemClickTrack(index, item), from_page: "3" });
                }}>
                <Radio
                  checked={curSelectIndex === index}
                  // onChange={() => handleRadioChange(index)}
                  value="a"
                  name="radio-buttons"
                  style={{ padding: 0 }}
                  inputProps={{ "aria-label": "A" }}
                />
                {cardFloor(item, index)}
              </div>
            </Grid>,
          ])}
        </Grid>}
      </div>
      <div
        className={isLogin ? styles.bottomFloat : styles.buttonContainer}
        exptag={"exp|" + EXPOSURE_RECORD.NeworderReceiverListPopup_NewAddress_Expo}
        data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
        data-exptag-json-param={JSON.stringify({ from_page: "3" })}
      >
        {isLogin && <Button className={styles.add} onClick={() => {
          setOpenCreateModal(true);
          sendClickTrack.NeworderReceiverListPopup_NewAddress({from_page: "3"});
        }}
          style={{ opacity: addressList && addressList?.length >= 30 ? 0.4 : 1 }}
          disabled={addressList && addressList?.length >= 30 ? true : false}>
          <AddressAdd /> Add a new address
        </Button>}
      </div>
      {/* 创建地址 弹窗 */}
      <UKDialog
        open={openCreateModal}
        onClose={handleClose}
        showCloseBtn={true}
        sx={{
          "& .MuiDialog-paper": {
            width: "880px", // 设置自定义宽度
            Height: "596px",
            // padding: "0px",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <Typography>
          <NewOrEditAddress
            handleClose={newCreateSaveClose}
            isHiddenSetDefault={true}
            isModal={true}
            isEdit={isUpdateOpenEdit}
            pageType={PAGE_TYPE.BILLING}
            data={isUpdateOpenEdit && addressList ? addressList[addressList.length - 1] : null}
            getUpdateAddress={getUpdateAddress} />
        </Typography>
      </UKDialog>
    </div>
  );
};
export default AddressBillingList;
